import {useEffect, useMemo, useRef} from 'react'
import {useSelector} from 'react-redux'
import {
  AUDIO_REDUCER, BOT_NAME,
  GENERAL_REDUCER,
  HIGHLIGHT_RANGE,
  USER_PROMPT_PREFIX, USER_PROMPT_SUFFIX
} from '../../redux/consts'
import {AUPRED_PROMPT_FUNC} from 'shared/common'
import styles from './SmartTextArea.module.scss'
import TextWithCursor from './TextWithCursor'
import {useDirection} from './useDirection'
import classes from 'classnames'

export default function ChatRenderer({ chat }) {

  const bottomRef = useRef(null)
  const lastAssistantIndex = useMemo(() => {
    return chat.reduce((lastIndex, { role }, index) => {
      return role === 'assistant' ? index : lastIndex;
    }, -1);
  }, [chat])

  const last = chat[chat.length - 1]
  useEffect(() => {
    bottomRef.current?.scrollIntoView({ block: 'nearest', behavior: 'auto' })
  }, [chat.length, last?.text])
  const highlightRange = useSelector(state => state.getIn([AUDIO_REDUCER, HIGHLIGHT_RANGE])).toJS()
  let newChat = chat

  // cursor should be shown only for the last assistant message
  return (
    <div className={styles.chatRenderer}>
      {newChat.map(({role, text, topN, selectedTopNIndex, isTopNPanelOpen}, index) =>
        <SingleChatParticle key={index}
                            text={text}
                            topN={topN}
                            role={role}
                            selectedTopNIndex={selectedTopNIndex}
                            isTopNPanelOpen={isTopNPanelOpen}
                            isWithCursorAndTopN={index === lastAssistantIndex}
                            highlightRange={index === lastAssistantIndex ? highlightRange : null}
        />)}
      <div ref={bottomRef} />
    </div>
  )
}

function SingleChatParticle({ role, isWithCursorAndTopN, text, topN, selectedTopNIndex, isTopNPanelOpen, highlightRange }) {
  const dir = useDirection(text)
  const avatar =
    role === 'assistant'
      ? '🤖'
      : role === 'user'
        ? '🧑'
        : null
  const botName = useSelector(state => state.getIn([GENERAL_REDUCER, BOT_NAME]))

  if (role === 'user'
    && text === USER_PROMPT_PREFIX+AUPRED_PROMPT_FUNC(botName)+USER_PROMPT_SUFFIX)
  {
    return null
  }

  return (
    <div
      className={classes(
        { [styles.particleContainerRtl]: dir === 'rtl' },
        { [styles.particleContainerLtr]: dir === 'ltr' },
        { [styles.assistantParticle]: role === 'assistant' }
      )}
    >
      {avatar && <span className={styles.roleAvatar}>{avatar}</span>}

      <div className={styles.particleTextWrap}>
        <TextWithCursor
          text={text}
          isWithCursorAndTopN={isWithCursorAndTopN}
          topN={topN}
          selectedTopNIndex={selectedTopNIndex}
          isTopNPanelOpen={isTopNPanelOpen}
          className={styles.charsContainer}
          highlightRange={highlightRange}
        />
      </div>
    </div>
  );
}
